import { getLockSellProductId } from "./lockPricing";

// One usage map per ticket prevents duplicate product rows from reusing a quota.
export function allocateSaleLocks(item, locks, netWeight, used, committed = false) {
  let remaining = Math.max(0, Number(netWeight) || 0);
  const allocations = [];
  const saved = item.lockPricingAllocations || [];
  const candidates = committed
    ? saved.map((allocation) => ({
        ...allocation.lockPricing, id: allocation.lockPricingId,
        specialPrice: allocation.pricePerUnit, saleRemainingWeight: allocation.weight,
      }))
    : [...locks].sort((a, b) => new Date(a.recordDate) - new Date(b.recordDate) || a.id - b.id);
  for (const lock of candidates) {
    if (getLockSellProductId(lock) !== Number(item.productId)) continue;
    const alreadyUsed = committed ? 0 : used.get(lock.id) || 0;
    const weight = Math.min(remaining, Math.max(0, Number(lock.saleRemainingWeight) - alreadyUsed));
    if (!Number.isFinite(weight) || weight <= 0) continue;
    allocations.push({ lockPricingId: lock.id, weight, pricePerUnit: Number(lock.specialPrice), lockPricing: lock });
    if (!committed) used.set(lock.id, alreadyUsed + weight);
    remaining -= weight;
  }
  return { allocations, remaining };
}
